import { FileText, Download, ExternalLink, Calendar } from "lucide-react";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { resolveUrl } from "@/lib/api";

export const DocumentCard = ({ item }) => {
  const fileUrl = resolveUrl(item.file_url);
  return (
    <div
      data-testid={`document-card-${item.id}`}
      className="group relative flex flex-col rounded-xl bg-[#14161A] border border-white/8 p-5 hover-lift hover:border-amber-500/50"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="p-3 rounded-lg bg-amber-500/10 border border-amber-500/20 text-amber-500">
          <FileText className="w-6 h-6" />
        </div>
        {item.status && <StatusBadge status={item.status} />}
      </div>
      <h3 className="mt-4 font-display text-xl font-bold uppercase text-white leading-tight">{item.title}</h3>
      {item.description && <p className="mt-1 text-sm text-white/55 line-clamp-2">{item.description}</p>}
      <div className="mt-2 flex items-center gap-2 text-xs font-mono text-white/40">
        {item.date && <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" />{item.date}</span>}
        <span className="uppercase">{item.category}</span>
      </div>
      <div className="mt-4 pt-4 border-t border-white/8 flex flex-wrap gap-2">
        {fileUrl && (
          <>
            <a href={fileUrl} target="_blank" rel="noreferrer" data-testid={`doc-open-${item.id}`}
              className="inline-flex items-center gap-2 rounded-md bg-amber-500 px-3 py-2 text-xs font-bold uppercase tracking-wide text-black hover:bg-amber-400 transition-colors">
              <ExternalLink className="w-3.5 h-3.5" /> Öppna PDF
            </a>
            <a href={fileUrl} download data-testid={`doc-download-${item.id}`}
              className="inline-flex items-center gap-2 rounded-md border border-white/15 px-3 py-2 text-xs font-bold uppercase tracking-wide text-white hover:border-amber-500/60 transition-colors">
              <Download className="w-3.5 h-3.5" /> Ladda ner
            </a>
          </>
        )}
        {item.external_url && (
          <a href={item.external_url} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-md border border-white/15 px-3 py-2 text-xs font-bold uppercase tracking-wide text-white hover:border-amber-500/60 transition-colors">
            <ExternalLink className="w-3.5 h-3.5" /> Länk
          </a>
        )}
        {!fileUrl && !item.external_url && (
          <span className="text-xs font-mono text-white/30 py-2">Publiceras senare</span>
        )}
      </div>
    </div>
  );
};
